import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Auth } from "aws-amplify";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { singinValidationSchema } from "../../../Utility/Validations";
import ForgotPassword from "../../forgotPassword/ForgotPassword";
import { checkvalidateTenant } from "../../../Utility/ApiService";
import { getMemberStatementId } from "../../../Utility";
import { clearLastAuthMethodIf } from "../../../Utility/lastAuthMethod";

function SignIn({ tenant, setLoading, setModalSuccess, setHideAuth }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(singinValidationSchema),
  });

  useEffect(() => {
    setHideAuth(showForgotPassword);
  }, [showForgotPassword]);

  const signInApi = async (data) => {
    try {
      setLoading(true);
      const userData = await Auth.signIn(data.email, data.password);
      let userGroups = userData.signInUserSession.accessToken.payload["cognito:groups"];
      let userRole = userGroups ? userGroups[0] : "Other";
      if (userRole === "Tenant") {
        const dd = await checkvalidateTenant({ email: data.email });
        if (dd.status !== 200) {
          clearLastAuthMethodIf("email"); // backend rejected this tenant — don't badge email as "Last used"
          Auth.signOut();
          if (dd.status === 404) {
            toast.error("Invalid Tenant Credentials");
          } else if (dd.status === 600) {
            toast.error(
              `Please contact your Landlord or Property Manager to restore access to your Tenant Portal account.`
            );
          } else {
            toast.error(`We are unable to log you in at this time, please contact your landlord/property manager.`);
          }
        } else {
          const memberStatementId = getMemberStatementId();
          navigate("/Dashboard", { state: { memberStatementId: memberStatementId || null } });
        }
      } else {
        toast.error("User's role is not Tenant");
      }
      setLoading(false);
    } catch (error) {
      console.log("error signin", error.message);
      setLoading(false);
      toast.error(error.message || "Invalid Tenant Credentials");
    }
  };

  return (
    <div>
      {showForgotPassword ? (
        <ForgotPassword
          setModalSuccess={setModalSuccess}
          setLoading={setLoading}
          setShowForgotPassword={setShowForgotPassword}
          showForgotPassword={showForgotPassword}
        />
      ) : (
        <form onSubmit={handleSubmit(signInApi)}>
          <div className={"mb-3 " + (errors.email && "error")}>
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input type="email" className="form-control" placeholder="Enter Email" {...register("email")} id="email" />
            <p>{errors.email?.message}</p>
          </div>

          <div className={"mb-3 " + (errors.password && "error")} id="password">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="field-group">
              <input
                className="form-control input-password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                {...register("password")}
              />
              <span
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
                toggle="#password"
                className={showPassword ? "fa fa-eye toggle-password" : "fa fa-eye-slash toggle-password"}
              />
            </div>
            <p>{errors.password?.message}</p>
          </div>

          <div className="text-end mb-4">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowForgotPassword(true);
              }}
            >
              <strong className="text-link">Forgot Password?</strong>
            </a>
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100"
            id="signin"
            onClick={(e) => {
              e.preventDefault(); // Prevent the default form submission
              handleSubmit((data) => signInApi(data))(); // Pass the form data to signInApi
            }}
          >
            Sign In
          </button>
        </form>
      )}
    </div>
  );
}

export default SignIn;
